import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PaymentCancelled.css';

function PaymentCancelled() {
  const navigate = useNavigate();

  return (
    <div 
      className="payment-cancelled-page"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/servicesection.webp)`
      }}
    >
      {/* Cancellation Content */}
      <div className="payment-cancelled-content">
        <div className="cancellation-box">
          <p className="cancellation-message">
            The payment was cancelled. No payment was processed. If you believe this was an error, try again. If this error persists, email matthew@backpass.co
          </p>
        </div>
        
        {/* Return button now outside the cancellation box */}
        <button
          onClick={() => navigate('/store')}
          className="return-button"
        >
          Return
        </button>
      </div>
    </div>
  );
}

export default PaymentCancelled;